import {services} from '../../../api';
import {
  DomainsData,
  ScrapeBody,
  SpecialityBody,
  SpecialityData,
  TypeOfStudyData,
} from '../../../interfaces/api/dashboard/scrapeArticle';
import {
  finishLoading,
  startLoading,
} from '../../../connected-components/loading/actions';

const staticBody = {
  Publisher: '',
  Speciality: '',
  SubSpeciality: '',
  TypeOfStudiesAndReaserch: '',
  Start: 0,
  Length: 231,
  Search: '',
  PdfContent: false,
  term: '',
};

export const getDomains = async (): Promise<DomainsData[] | null> => {
  try {
    const res = await services.dashboard.getDomains();
    return res?.data;
  } catch (error) {
    if (process.env.REACT_APP_DEBUG === 'true') {
      console.info('GET DOMAINS FAIL: ', error);
    }
    return null;
  }
};

export const getSpeciality = async (
  body?: SpecialityBody,
): Promise<SpecialityData[] | null> => {
  try {
    const res = await services.dashboard.getSpeciality({
      ...staticBody,
      ...(body || {}),
    });
    return res?.data;
  } catch (error) {
    if (process.env.REACT_APP_DEBUG === 'true') {
      console.info('GET SUB / SPECIALITY FAIL: ', error);
    }
    return null;
  }
};

export const getTypeOfStudy = async (
  body?: SpecialityBody,
): Promise<TypeOfStudyData[] | null> => {
  try {
    const res = await services.dashboard.getTypeOfStudy({
      ...staticBody,
      ...(body || {}),
    });
    return res?.data;
  } catch (error) {
    if (process.env.REACT_APP_DEBUG === 'true') {
      console.info('GET TYPE OF STUDY FAIL: ', error);
    }
    return null;
  }
};

export const scrapeArticle = async (body: ScrapeBody): Promise<boolean> => {
  try {
    startLoading();
    const res = await services.dashboard.scrapeArticles(body);
    if (res?.code === 200) return true;
  } catch (error) {
    if (process.env.REACT_APP_DEBUG === 'true') {
      console.info('SCRAPE FAIL: ', error);
    }
    return false;
  } finally {
    finishLoading();
  }
};
